/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './not-found.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../app/not-found/not-found.component';
const styles_NotFoundComponent:any[] = [import0.styles];
export const RenderType_NotFoundComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_NotFoundComponent,
  data: {}
}
);
export function View_NotFoundComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Page not found'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(null as any),(null as any));
}
function View_NotFoundComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-not-found',([] as any[]),(null as any),(null as any),(null as any),View_NotFoundComponent_0,RenderType_NotFoundComponent)),
    import1.ɵdid(49152,(null as any),0,import2.NotFoundComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const NotFoundComponentNgFactory:import1.ComponentFactory<import2.NotFoundComponent> = import1.ɵccf('app-not-found',import2.NotFoundComponent,View_NotFoundComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ub3QtZm91bmQvbm90LWZvdW5kLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92ZXJjZWwvd29ya3BhdGgwL3NyYy9hcHAvbm90LWZvdW5kL25vdC1mb3VuZC5jb21wb25lbnQudHMiLCJuZzovLy92ZXJjZWwvd29ya3BhdGgwL3NyYy9hcHAvbm90LWZvdW5kL25vdC1mb3VuZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ub3QtZm91bmQvbm90LWZvdW5kLmNvbXBvbmVudC50cy5Ob3RGb3VuZENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxoMj5QYWdlIG5vdCBmb3VuZDwvaDI+XG4iLCI8YXBwLW5vdC1mb3VuZD48L2FwcC1ub3QtZm91bmQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtJQUFJO0lBQW1COzs7Ozs7SUNBdkI7Z0JBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/not-found/not-found.component.ngfactory.ts